import {NgModule} from '@angular/core';

import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {AcNumSpinnerComponent} from './ac-num-spinner.component';
import {MatInputModule} from '@angular/material/input';
import {InfraPipesModule} from '../../pipes/infra.pipes.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MatInputModule,
        InfraPipesModule,
    ],
    declarations: [
        AcNumSpinnerComponent,
    ],
    exports: [
        AcNumSpinnerComponent,
    ]
})
export class AcNumSpinnerModule {
}
